import { render, staticRenderFns } from "./LinkToRequest.vue?vue&type=template&id=0c7da12e"
import script from "./LinkToRequest.vue?vue&type=script&lang=js"
export * from "./LinkToRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports